import { DtoLogsChannel } from '../../../../../services/tools/channels/logsChannels/types/dtoLogsChannel';
import { DtoPaginatedResult } from '../../../../../services/tools/channels/logsChannels/types/dtoPagination';
import { Table } from '@polichat/flamboyant';
import TablePagination from '../../../../shopping/TablePagination';
import { FormatedDate, FormatedTypeChange } from './helpers';
import Animation from '../../../../common/animation';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

export interface ResultLogsProps {
  items?: DtoPaginatedResult<DtoLogsChannel>;
  loading?: boolean;
  onPageChange: (page: number) => void;
}

export function ResultLogs(props: ResultLogsProps) {
  const totalItens = props.items?.pagination?.total;
  
  // Traduções
  const channelText = useGlotaT('spa.tools.logsTableChannel');
  const dateText = useGlotaT('spa.tools.logsTableDate');
  const userText = useGlotaT('spa.tools.logsTableUser');
  const typeText = useGlotaT('spa.tools.logsTableType');
  
  // Mapeamento de traduções dinâmicas
  const activatedText = useGlotaT('spa.tools.logsActivated');
  const deactivatedText = useGlotaT('spa.tools.logsDeactivated');
  const deletedText = useGlotaT('spa.tools.logsDeleted');
  const disconnectedText = useGlotaT('spa.tools.logsDisconnected');
  const connectedText = useGlotaT('spa.tools.logsConnected');
  
  const getTypeChangeTranslation = (type: string) => {
    switch(type) {
      case 'ativado': return activatedText;
      case 'desativado': return deactivatedText;
      case 'excluido': return deletedText;
      case 'desconectado': return disconnectedText;
      case 'conectado': return connectedText;
      default: return type;
    }
  };
  
  return (
    <>
      {props.loading ? (
        <Animation
          icon="chat-loading"
          top={'50%'}
          style={{
            maxWidth: '150px',
            height: '100%',
            maxHeight: '100px',
          }}
        />
      ) : (
        <Table className="table table-striped table-hover">
          <thead>
            <tr style={{ fontWeight: 'bold', fontSize: '1.25rem' }}>
              <th>{channelText}</th>
              <th>{dateText}</th>
              <th>{userText}</th>
              <th>{typeText}</th>
            </tr>
          </thead>
          <tbody>
            {props.items?.data.map((log) => (
              <tr key={log.id}>
                <th>{log.channel_name}</th>
                <th>{FormatedDate(log.date_change)}</th>
                <th>{log.user_name}</th>
                <th>{getTypeChangeTranslation(log.type_change)}</th>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      <TablePagination
        totalItens={totalItens}
        limitItens={props.items?.pagination.per_page}
        pageSide={1}
        onPageChange={(page: any) => props.onPageChange(page.currentPage)}
      />
    </>
  );
}
